module.exports = __webpack_public_path__ + "img/hohlsaum_anthrazitgrau_ral7016.7eafec76.jpg";